import { render, staticRenderFns } from "./manageStoreKor.vue?vue&type=template&id=20076405&"
import script from "./manageStoreKor.vue?vue&type=script&lang=js&"
export * from "./manageStoreKor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports